<span 
  [class]="'timeline__hour' + ' ' + status() + ' ' + 'ci-paragraph-p3-semibold'"
>
  <ng-content></ng-content>
</span>
